/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { connect } from "react-redux";
// import { Accordion, Card } from "react-bootstrap";
// import _ from "lodash";
import Pagination from "react-js-pagination";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { getSurveys } from "actions";
// import "components/invoices/invoice.css";
import SurveysTable from "components/survey/SurveysTable";
import { Trans } from "react-i18next";
import i18n from "i18next";

// const mobileCategoryListVisibleStyle = { visibility: "visible", opacity: "1" };
// const mobileCategoryListInVisibleStyle = { visibility: "hidden", opacity: "0" };
class SurveyContainer extends Component {
  state = {
    teamFetched: false,
    filteredSurveyData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.fetchSurveys();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredSurveyData: this.props.survey.surveys.filter((s) => {
          return (
            s.survey.name
              .toLowerCase()
              .includes(this.state.filterTerm.toLowerCase()) ||
            s.subject
              .toLowerCase()
              .includes(this.state.filterTerm.toLowerCase())
          );
        }),
      });
    }
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({
      teamFetched: true,
      filteredSurveyData: this.props.survey.surveys,
    });
  };

  fetchSurveys = () => {
    this.props.getSurveys(this.onBegin, this.onSuccess, this.onError);
  };

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFetch = () => {
    this.setState({ teamFetched: false });
    // console.log(this.state.selectedYear);
    // console.log(this.state.selectedMonth);
    this.fetchSurveys();
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderTableToolbar = () => {
    return (
      <div className="row align-items-center py-3 eduTitleArea">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
              <div className="inner-addon right-addon">
                <span className="iconmford fo-icon-search"></span>
                <input
                  type="text"
                  name="tableSearch"
                  id="tableSearch"
                  className="form-control"
                  placeholder={i18n.t("10053")} //Bul
                  onChange={(e) => this.handleFilter(e)}
                  value={this.state.filterTerm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderPager = () => {
    return (
      <div
        style={{
          display: "grid",
          justifyContent: "right",
          marginRight: "20px",
        }}
      >
        <Pagination
          hideFirstLastPages={true}
          prevPageText="Önceki"
          nextPageText="Sonraki"
          hideDisabled={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={this.state.filteredSurveyData.length}
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  render() {
    if (!this.state.teamFetched) {
      return this.props.spinner;
    }

    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    return (
      <section className="sssArea my-3">
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Kurumsal">10026</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Anket">10042</Trans> / Test
                </li>
              </ul>
            </div>
          </div>
          {this.renderTableToolbar()}

          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <SurveysTable
                data={this.state.filteredSurveyData.slice(start, end)}
                fullname={this.props.fullname}
              />
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-0 col-sm-0 col-md-9 col-lg-9"></div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              {this.renderPager()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ survey, application, profile }) => {
  return {
    survey: survey.data,
    application,
    fullname: profile.general.fullname,
  };
};

export default connect(mapStateToProps, { getSurveys })(
  containsLongRunningProcess(requireAuth(SurveyContainer))
);
